import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormikField } from "@air/formik-field";
import { Input } from "@air/primitive-input";
import { useField } from "formik";
import { memo, useEffect } from "react";
import { CUSTOM_FIELD_MODAL_FORM_DESCRIPTION, CUSTOM_FIELD_MODAL_FORM_TITLE } from "../../CustomFieldModal";
import { FormikCustomFieldTypeSelect } from "./FormikCustomFieldTypeSelect";
export const CustomFieldModalFormBaseFields = /*#__PURE__*/ memo((param)=>{
    let { modalDescription, canEditFieldType, fieldTypes, handleDisableSave } = param;
    const [_t, titleMetadata] = useField(CUSTOM_FIELD_MODAL_FORM_TITLE);
    const [_d, descriptionMetadata] = useField(CUSTOM_FIELD_MODAL_FORM_DESCRIPTION);
    const hasBaseFieldErrors = !!(descriptionMetadata.error || titleMetadata.error);
    useEffect(()=>{
        handleDisableSave(hasBaseFieldErrors);
    }, [
        hasBaseFieldErrors,
        handleDisableSave
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-6 flex flex-col gap-6",
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "text-16 text-grey-11",
                children: modalDescription
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col items-baseline gap-3 md:flex-row",
                children: [
                    /*#__PURE__*/ _jsx(FormikField, {
                        id: "name",
                        className: "flex-1",
                        component: /*#__PURE__*/ _jsx(Input, {
                            autoFocus: true,
                            "data-1p-ignore": true,
                            placeholder: "e.g. Priority",
                            size: "large"
                        }),
                        label: "Field Title *",
                        name: "name"
                    }),
                    /*#__PURE__*/ _jsx(FormikCustomFieldTypeSelect, {
                        className: "flex-1",
                        canEditFieldType: canEditFieldType,
                        fieldTypes: fieldTypes
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(FormikField, {
                id: "description",
                className: "flex-1",
                component: /*#__PURE__*/ _jsx(Input, {
                    "data-1p-ignore": true,
                    placeholder: "Describe your custom field in a sentence",
                    size: "large"
                }),
                label: "Description",
                name: "description"
            })
        ]
    });
});
CustomFieldModalFormBaseFields.displayName = "CustomFieldModalFormBaseFields";
